export const TIME_DIGIT = /^[0-9]$/;
export const HOUR_SYMBOL = {
    value: 'h',
    match: TIME_DIGIT.test.bind(TIME_DIGIT),
    placeholderCharacter: 'h',
};

export const MINUTE_SYMBOL = {
    value: 'm',
    match: TIME_DIGIT.test.bind(TIME_DIGIT),
    placeholderCharacter: 'm',
};

export const timeMatchableSymbols = [HOUR_SYMBOL, MINUTE_SYMBOL];
